import { render, staticRenderFns } from "./PageWrap.vue?vue&type=template&id=24156eee&"
import script from "./PageWrap.vue?vue&type=script&lang=js&"
export * from "./PageWrap.vue?vue&type=script&lang=js&"
import style0 from "./PageWrap.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports